import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Auth0Provider } from '@auth0/auth0-react';
import { Notifications } from '@mantine/notifications';
import { ModalsProvider } from '@mantine/modals';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import App from './App';
import { AuthInject } from './api/auth-inject';
import { AUTH0_AUDIENCE, AUTH0_CLIENT_ID, AUTH0_DOMAIN } from './magic-values';
import { BagelMantineProvider } from './theme';
import './index.css';

const queryClient = new QueryClient();

const container = document.getElementById('root');
if (!container) {
  throw new Error('Root element #root not found');
}
const root = createRoot(container);

const onRedirectCallback = (appState?: { returnTo?: string }) => {
  const returnTo = appState?.returnTo ?? window.location.pathname;
  window.history.replaceState({}, document.title, returnTo);
};

root.render(
  <React.StrictMode>
    <Auth0Provider
      domain={AUTH0_DOMAIN}
      clientId={AUTH0_CLIENT_ID}
      authorizationParams={{
        redirect_uri: window.location.origin,
        audience: AUTH0_AUDIENCE,
      }}
      onRedirectCallback={onRedirectCallback}
      cacheLocation="localstorage"
    >
      <AuthInject />
      <QueryClientProvider client={queryClient}>
        <BagelMantineProvider>
          <ModalsProvider>
            <Notifications />
            <BrowserRouter>
              <App />
            </BrowserRouter>
          </ModalsProvider>
        </BagelMantineProvider>
      </QueryClientProvider>
    </Auth0Provider>
  </React.StrictMode>,
);
